import axios from "axios";


export const submitContactUs = async (data) => {
    try {
        const response = await axios.post(
            `/api/contact-email`,
            data,
            {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                },
            }
        );
        return response.data; // Return the response data to the caller
    } catch (error) {
        // console.error('Error fetching tag status:', error);
        throw error; // Rethrow the error to be handled by the caller
    }
}

export const submitClientRequest = async (data) => {
    try {
        const response = await axios.post(
            `/api/client-request`,
            data,
            {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                },
            }
        );
        return response.data; // Return the response data to the caller
    } catch (error) {
        // console.error('Error fetching tag status:', error);
        throw error; // Rethrow the error to be handled by the caller
    }
}

export const registerExpert = async (data) => {
    try {
        const response = await axios.post(
            `/api/register-expert`,
            data,
            {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                },
            }
        );
        return response.data; // Return the response data to the caller
    } catch (error) {
        // console.error('Error fetching tag status:', error);
        throw error; // Rethrow the error to be handled by the caller
    }
}